import { StyleSheet } from "react-native";
import { AppTheme } from "../../../theme";

export const quickProductEditStyle = (theme: AppTheme) => StyleSheet.create({
    keyboardAvoidingView: {
        flex: 1
    },
    loaderView: {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme?.light
    },
    scrollView: {
        paddingHorizontal: 10,
        paddingVertical: 20
    },
    inputContainer: {
        paddingHorizontal: 15,
    },
    inputInnerContainer: {
        paddingHorizontal: 8
    },
    dropdownContainer: {
        paddingHorizontal: 15
    },
    weightUnitContainer: {
        paddingHorizontal: 15,
        paddingVertical: 20
    },
    errorStyle: {
        fontSize: theme?.errorFontSize,
        fontFamily: theme?.medium,
        color: theme?.red,
    },
    actionView: {
        columnGap: 10,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingRight: 20,
        paddingVertical: 15,
        borderTopWidth: 0.4,
        borderTopColor: theme?.grey
    },
    loadingStyle: {
        paddingHorizontal: 10
    }
})
